/**
 * Twenty CRM Dashboard Page
 *
 * Placeholder component — the actual Twenty CRM iframe is rendered
 * by PersistentTwentyCrm in MainLayout to keep it mounted across navigation.
 *
 * Mirrors CrmDashboardPage / BlogDashboardPage pattern.
 */

export function TwentyCrmDashboardPage() {
  return null;
}
